import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { runAiJob } from '../../lib/aiJob';

const box = 'w-full min-w-0 rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm';

// Query the official PJUD search: court + code/law + article (or text), optionally compared with one of your cases
export const TrendForm = ({ meta, matters, onDone }) => {
  const { api } = useAuth();
  const [f, setF] = useState({ tribunal: 'corte_suprema', norm_id: '', ley: '', articulo: '', texto: '', matter_id: '' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const run = async () => {
    setBusy(true);
    try {
      const r = await runAiJob(api, '/court-trends', { ...f, norm_id: f.norm_id || null, ley: f.norm_id ? null : f.ley || null, articulo: f.articulo || null, texto: f.texto || null, matter_id: f.matter_id || null }, { timeout: 300000 });
      toast.success(`${r.stats.n} sentencias oficiales analizadas`); onDone(r.id);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div data-testid="trend-form" className="grid grid-cols-1 gap-3 rounded-2xl border border-slate-800 bg-slate-900/60 p-5 md:grid-cols-3 [&>*]:min-w-0">
      <select data-testid="trend-tribunal" value={f.tribunal} onChange={set('tribunal')} className={box}>{Object.entries(meta.tribunales).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
      <select data-testid="trend-codigo" value={f.norm_id} onChange={set('norm_id')} className={box}><option value="">Ley por número →</option>{Object.entries(meta.codigos).map(([k, v]) => <option key={k} value={k}>Código {v.toLowerCase()}</option>)}</select>
      <input data-testid="trend-ley" disabled={!!f.norm_id} value={f.ley} onChange={set('ley')} placeholder="N° de ley, ej. 18101" className={`${box} disabled:opacity-40`} />
      <input data-testid="trend-articulo" value={f.articulo} onChange={set('articulo')} placeholder="Artículo (opcional), ej. 7" className={box} />
      <input data-testid="trend-texto" value={f.texto} onChange={set('texto')} placeholder="Texto (opcional), ej. restitución" className={box} />
      <select data-testid="trend-matter" value={f.matter_id} onChange={set('matter_id')} className={box}><option value="">Comparar con una causa (opcional)</option>{matters.map((m) => <option key={m.id} value={m.id}>{m.title}</option>)}</select>
      <button data-testid="trend-run" disabled={busy || (!f.norm_id && !f.ley && !f.texto)} onClick={run} className="flex w-fit items-center gap-2 rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-40">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />}{busy ? 'Consultando el Poder Judicial…' : 'Analizar sentencias oficiales'}
      </button>
    </div>
  );
};
